function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useCallback } from 'react';
import { useOpenLayers } from '../react-ol';
import findFeatureInLayers from '../utils/findFeatureInLayers';
/**
 * @deprecated since version 1.26.0
 *
 * Use `useFitFeatures` hook instead
 *
 */

var useFitFeature = () => {
  var {
    map
  } = useOpenLayers();
  return useCallback(function (id) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (map) {
      var layers = map.getLayers().getArray();

      if (layers.length > 0) {
        var foundFeature = findFeatureInLayers(layers, id);

        if (foundFeature) {
          var _foundFeature$getGeom;

          var geometry = (_foundFeature$getGeom = foundFeature.getGeometry()) === null || _foundFeature$getGeom === void 0 ? void 0 : _foundFeature$getGeom.getExtent();

          if (geometry) {
            map.getView().fit(geometry, _objectSpread({
              duration: 150
            }, options));
          }
        } else console.warn('Could not find feature in layers.');
      } else console.warn('Could not fitFeature. No layers were rendered.');
    }
  }, [map]);
};

export default useFitFeature;